<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('用户编号')">
        <el-input :placeholder="$t('用户编号')" v-model="searchForm.userNum" clearable/>
      </el-form-item>
      <el-form-item :label="$t('用户昵称')">
        <el-input :placeholder="$t('用户昵称')" v-model="searchForm.username" clearable/>
      </el-form-item>
      <el-form-item :label="$t('等级名称')">
        <el-select value="" clearable :placeholder="$t('等级名称')" v-model="searchForm.levelName" filterable>
          <el-option v-for="item in levelList" :key="item.code" :value="item.code" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('菜谱编号')">
        <el-input :placeholder="$t('菜谱编号')" v-model="searchForm.cookbookNum" clearable/>
      </el-form-item>
      <el-form-item :label="$t('菜谱昵称')">
        <el-input :placeholder="$t('菜谱昵称')" v-model="searchForm.cookbookName" clearable/>
      </el-form-item>
      <el-form-item :label="$t('发布时间')">
        <date-time-range-picker
            :start-time.sync="searchForm.startTime"
            :end-time.sync="searchForm.endTime" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          :request-params="{vipType: 'user'}"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event" :sort-method="dateSortMethod" >

        <el-table-column type="selection" width="50"/>
        <el-table-column
            type="index"
            width="50" :label="$t('序号')" >
        </el-table-column>
        <el-table-column prop="userNum" :label="$t('用户编号')" />
        <el-table-column prop="userName" :label="$t('用户昵称')" sortable />
        <el-table-column prop="levelName" :label="$t('等级名称')" sortable/>
        <el-table-column prop="cookbookNum" :label="$t('菜谱编号')" sortable/>
        <el-table-column prop="cookbookName" :label="$t('菜谱昵称')"/>
        <el-table-column prop="integral" :label="$t('获取积分')"/>
        <el-table-column :label="$t('使用时间')" sortable prop="createTime">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" width="90">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "UserLevelRecord",
  components: {AnkhList, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      levelList: []
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.userIntegralRecord.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if (!codes.length) {
          this.$message.error(this.$t('请选择要删除的数据'));
          return;
        }
        await requestByTip(
            this.$api.userIntegralRecord.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.userIntegralRecord.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    // 等级列表
    async getLevelList() {
      try {
        const res = await request(this.$api.userVipLevel.list, {onPage: false});
        this.levelList = res.userVipLevels;
      } catch (e) {
        console.log(e);
      }
    },
    dateSortMethod(a, b) {
      let dateA = new Date(a.createTime);
      let dateB = new Date(b.createTime);
      return dateA - dateB;
    }

  },
  created() {
    this.getLevelList();
  }
}
</script>

<style scoped>

/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
